
// src/hooks/useAuth.tsx
import React, { createContext, useContext } from "react"
import { useAuthLogic } from "./useAuthLogic"

// ------------------------
// Context
// ------------------------
const AuthContext = createContext<ReturnType<typeof useAuthLogic> | undefined>(
  undefined
)

// ------------------------
// Provider
// ------------------------
export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const auth = useAuthLogic()
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}

// ------------------------
// Hook for consuming
// ------------------------
export const useAuth = () => {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider")
  return ctx
}
